import axios from 'axios';
import sleep from '@/_vue/helpers/sleep';

const state = {
    deliveryText: '',
    isLoading: true,
    items: [],
    summary: {},
    upsellItems: [],
    basketRoute: null,
};

const actions = {
    async fetchBasket({ commit }) {
        commit('setLoading');
        await sleep(300);

        // const { data } = await axios.get('/json/basket.json');
        const { data } = await axios.get(state.basketRoute);
        commit('setItems', data);
    },
};

const mutations = {
    setLoading(state) {
        state.isLoading = true;
    },

    async setItems(state, data) {
        state.deliveryText = data.delivery_text;
        state.items = data.items;
        state.summary = data.summary;
        state.upsellItems = data.upsell_items;
        state.isLoading = false;

        const headerBasketCount = document.querySelector('.js-header-basket-count');

        if (!headerBasketCount) return;
        const totalItems = (data.total_items > 99) ? '99+' : data.total_items;
        headerBasketCount.innerText = totalItems;
    },

    setBasketDefaults(state, data) {
        state.basketRoute = data.basketRoute;
    },
};

export default {
    namespaced: true,
    actions,
    mutations,
    state,
};
